module.exports = __webpack_public_path__ + "img/Group.bdc59373.svg";